import { render } from "./CatalogGlasess.vue?vue&type=template&id=0a11be50&scoped=true"
import script from "./CatalogGlasess.vue?vue&type=script&lang=js"
export * from "./CatalogGlasess.vue?vue&type=script&lang=js"

import "./CatalogGlasess.vue?vue&type=style&index=0&id=0a11be50&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dymek\\Desktop\\Projects\\Lusterka Adam\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a11be50"]])

export default __exports__